import { Card, CardContent } from "@/components/ui/card";

interface StatCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  onClick?: () => void;
  "data-testid"?: string;
}

export function StatCard({ label, value, subtext, onClick, "data-testid": testId }: StatCardProps) {
  return (
    <Card 
      className={onClick ? "cursor-pointer hover:bg-accent transition-colors" : ""} 
      onClick={onClick}
      data-testid={testId}
    >
      <CardContent className="pt-6">
        <div className="text-xl sm:text-3xl font-bold text-primary mb-2">{value}</div>
        <p className="text-sm text-muted-foreground">{label}</p>
        {subtext && <p className="text-xs text-muted-foreground mt-1">{subtext}</p>}
      </CardContent>
    </Card>
  );
}
